"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBriefcaseSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M24 14.787v6.653a1.52 1.52 0 01-1.515 1.517H1.515A1.52 1.52 0 010 21.44v-6.653h24zM14.45 1c1.266 0 2.31.991 2.395 2.236l.005.164v1.685h5.634c.789 0 1.439.608 1.509 1.38l.006.138v6.652H0V6.603c0-.79.606-1.442 1.378-1.512l.138-.006h5.632L7.15 3.4c0-1.266.992-2.31 2.237-2.394L9.549 1h4.902zm-1.43 9.191H10.98l-.104.007a.766.766 0 00.104 1.525h2.043l.104-.007a.766.766 0 00-.104-1.525zm1.43-7.66H9.55a.875.875 0 00-.86.761L8.68 3.4v1.685h6.638V3.4a.875.875 0 00-.76-.861l-.108-.007z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBriefcaseSolid;
exports.default = _default;